<template>
  <customModal
    :containersm="true"
    :footerShow="true"
    @closeModal="closeRiskModal"
  >
    <template #title>{{ title }} </template>
    <template #body>
      <div class="table-responsive mt-2 scrollable">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>{{ $t("navigations.site code") }}</th>
              <th>{{ $t("navigations.category") }}</th>
              <th>{{ $t("navigations.sub category") }}</th>
              <th>{{ $t("navigations.execution type") }}</th>
              <th>{{ $t("navigations.created on") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.entities" :key="item.id">
              <td>{{ item.siteName }}</td>
              <td>{{ item.category }}</td>
              <td>{{ item.subCategory }}</td>
              <td>{{ item.executionType }}</td> 
              <td>{{ item.executionType }}</td> 
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer> </template>
  </customModal>
</template>
<script src="./RiskListPopup.js"></script>

<style scoped>
</style>